import { MODES } from "../constants/modes";

export const getCurrentMode = (isLive: boolean) => {
  const mode = isLive ? MODES.LIVE : MODES.TEST;
  return mode;
};